import classnames from 'classnames';
import {
  ImageEmbed as V3ImageEmbed,
  ImageEmbedProps,
} from '@stadionhq-v3/base-ui';
import { THEME_IDS } from '@stadionhq-v3/core';
import styles from './imageEmbed.module.scss';

const ImageEmbed = ({ ...props }: ImageEmbedProps) => {
  const classes = classnames([
    styles.imageEmbedTokens,
    styles.imageEmbed,
    styles.default1,
  ]);

  return (
    <V3ImageEmbed
      {...props}
      classNames={[classes]}
      theme={{ themeId: THEME_IDS.DEFAULT_1, title: 'Colour Theme 1' }}
    />
  );
};

export default ImageEmbed;
